import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  backgroundColor: (p) => `${p.palette.common.white} !important`,
  borderBottomColor: (p) => `${p.palette.grey[300]} !important`,
};

export const actions: SxStyle = {
  flexDirection: 'row-reverse',
  placeContent: 'end',
  borderTopColor: (p) => `${p.palette.grey[300]} !important`,
};

export const button: SxStyle = {
  whiteSpace: 'nowrap',
  color: 'white',
};
